export const HOUR = '1 hour'
export const DAY = '24 hours'
export const TWO_DAYS = '48 hours'
export const WEEK = '1 week'
export const TWO_WEEKS = '2 weeks'
